import { BreakpointsOptions, Theme } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import { components } from './components';
import { DarkPalette, LightPalette } from './palette';
import { defaultTypography } from './typography';

const baseTheme = createTheme({ palette: DarkPalette });
const baseLightTheme = createTheme({ palette: LightPalette });

const BreakpointOptions: BreakpointsOptions = {
  values: {
    xs: 0,
    sm: 600,
    md: 905,
    lg: 1280,
    xl: 1440,
  },
};

const muiDarkTheme = createTheme({
  breakpoints: BreakpointOptions,
  components: components(baseTheme),
  palette: DarkPalette,
  typography: defaultTypography,
});

const muiLightTheme = createTheme({
  breakpoints: BreakpointOptions,
  components: components(baseLightTheme),
  palette: LightPalette,
  typography: defaultTypography,
});

export const themes: { [domain: string]: Theme } = {
  marketplace: muiDarkTheme,
  marketplaceLight: muiLightTheme,
};
